import { IAuthState } from './types';

export const initialState: IAuthState = {
  signIn: {},
  loading: false
};
